
import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-nova-lite',
  templateUrl: './nova-lite.component.html',
  styleUrls: ['./nova-lite.component.scss']
})

export class NovaLiteComponent {
  constructor(private dialogRef: MatDialogRef<NovaLiteComponent>) {}

  close() {
    this.dialogRef.close();
  }
}
